import { gtmSendEvent } from "@wojo/analytics";
import { Text, VideoPlayer } from "@wojo/ui";
import { useVideoMetadata } from "@wojo/services";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

type TourVideoPlayerProps = {
    wistiaVideoId: string;
};

const TourVideoPlayerInternal: React.FC<TourVideoPlayerProps> = ({
    wistiaVideoId,
}) => {
    const { data: videoMetadata } = useVideoMetadata(wistiaVideoId);

    return (
        <VideoPlayer
            videoId={wistiaVideoId}
            requestAutoplay={false}
            fallbackImageUrl={videoMetadata?.url}
            fallbackImageAlt={videoMetadata?.videoTitle}
            loopVideo={true}
            playerColor="#191919"
            style={{
                width: "100%",
                height: "100%",
            }}
            onPlaybackChange={(videoState) => {
                gtmSendEvent({
                    event: "track",
                    ga4_object: "TOUR_VIDEO_PLAYER",
                    ga4_action: videoState.toUpperCase(),
                    videoId: wistiaVideoId,
                });
            }}
        />
    );
};

export const TourVideoPlayer: React.FC<TourVideoPlayerProps> = (props) => {
    return (
        <ErrorBoundary fallback={<Text.Body>Error loading content</Text.Body>}>
            <TourVideoPlayerInternal {...props} />
        </ErrorBoundary>
    );
};
